import common from '@/utils/common'
import store from '@/store'
import hostPath from '@root/config/host'
import apiPath from '@config/api.json'
import { Loading } from 'element-ui'
import './login.scss'
import template from './login.tpl'
import languageObj from './login-lan.json'
import headerNoLogin from '@/components/common/headerNoLogin/header-no-login'
import footerComponent from '@/components/common/footer/footer-component'
const { mapState } = require('vuex')
const projectData = require('@/utils/projectData.json')
const getSysType = hostPath.sysType
const sha256 = require('js-sha256').sha256
// 登录
export default {
  template,

  name: 'login',

  computed: {
    ...mapState({
      lan: state => {
        return state.sys.lan
      }
    })
  },

  // 注册组件
  components: { headerNoLogin, footerComponent },

  data () {
    return {
      LANMSG: {},
      form: {
        // 登录表单
        name: '',
        pwd: '',
        checked: common.getUserLSn() !== '', // 在保存密码时会用到
        sysType: ''
      },
      forgotPwd: this.clearForgotPwd(),
      userId: '', // 登录时返回的用户id，首次登录修改密码时用到
      token: '', // 登录时返回的用户token，首次登录修改密码时用到
      modifyPwd: {
        // 设置初始密码
        dialogVisible: false,
        labelWidth: '130px',
        newPwd1: '',
        newPwd2: ''
      },
      isLogining: false
    }
  },

  watch: {
    lan: function (n) {
      this.setLanguageMsg(n)
    },
    $route (to, from) {
      this.checkToLogin()
    }
  },

  // 实例创建后,进行默认数据处理
  created () {
    // 清除登录信息
    common.clearLoginInfo()
    this.setLanguageMsg(this.lan)
    this.checkToLogin()
  },

  // html挂载在页面后,进行数据初始化
  mounted () {},

  // 方法集合
  methods: {
    // 设置语言文字
    setLanguageMsg (lan) {
      this.LANMSG = languageObj[lan]
      if (common.isEnLan()) {
        document.title = projectData[getSysType].titleEn
      } else {
        document.title = projectData[getSysType].title
      }
    },
    checkToLogin () {
      const getQuery = this.$route.query
      if (getQuery.hs) {
        const getArr = common.doDecrypt(getQuery.hs).split('-->')
        const getPwd = common.doDecryptTfp(getArr[1])
        let sendData = {
          name: getArr[0],
          pwd: getPwd
        }
        this.onSubmitFun(sendData)
      }
    },
    onSubmit () {
      if (this.isLogining) {
        return false
      }
      // 验证用户ID
      let getLName = this.form.name
      if (getLName === '') {
        return common.warningInfoTip(this.LANMSG.form.userNameTips)
      }

      // 验证用户密码
      let getLPwd = this.form.pwd
      if (getLPwd === '') {
        return common.warningInfoTip(this.LANMSG.form.userPwdTips)
      }

      // 用户昵称处理
      let setLName = getLName
      const getCLName = common.getUserName() // 获得cookie中的用户昵称
      if (getCLName && setLName === getCLName) {
        setLName = getLName
      }

      // 用户密码处理
      let setLPwd = getLPwd
      const getCLPwd = common.getUserLSn() // 获得cookie中的用户密码
      if (getCLPwd && getLPwd === getCLPwd) {
        setLPwd = getLPwd
      }

      // 如果勾选了记住密码
      if (this.form.checked) {
        common.setCookie('dtcLUName', setLName) // 用户昵称
        common.setCookie('dtcLSn', setLPwd) // 用户加密后的密码
      } else {
        common.delCookie('dtcLUName')
        common.delCookie('dtcLSn')
      }
      this.onSubmitFun(this.form)
    },
    onSubmitFun (sendData) {
      this.isLogining = true
      let sha256pwd = sha256(sendData.pwd)
      this.$ajax({
        method: 'post',
        url: `${apiPath.common.login}`,
        withCredentials: false,
        data: {
          userName: sendData.name,
          passwd: common.doEncrypt(sha256pwd)
        }
      })
        .then(res => {
          if (res && res.data) {
            // 存放好处理后的菜单列表
            let resData = res.data
            // 存储token
            let data = resData.user
            const setPlatform = window.JSON.stringify(data.platform)
            const setAgent = window.JSON.stringify(data.agent)
            const channelNo = data.channelNo
            window.sessionStorage.setItem('user', JSON.stringify(data))
            common.setLoginInfo(
              data.token,
              data.userId,
              '',
              data.userName,
              data.isAllPermission,
              data.platformNo,
              data.agentNo,
              setPlatform,
              setAgent,
              channelNo,
              resData.lastLoginDate,
              data.platformHost,
              data.permissionNo,
              resData.org
            )
            store.dispatch('getItemSys', {
              tk: data.token,
              uId: data.userId
            })
            // 菜单处理
            let allMenuList = resData.listMenu || []
            // 默认显示第一个显示的菜单
            let jumpRouterName = ''
            // 循环中是否已找到了第一个显示的菜单
            let isHasMenu = false
            // 补全路由地址,
            allMenuList.forEach(v => {
              if (v.menuLevel === 2) {
                // 对主导航有了导航时进行处理
                if (!v.menuUrl) {
                  resData.listMenu.some(subV => {
                    if (subV.menuLevel === 3) {
                      if (subV.parentMenuId === v.menuId) {
                        v.menuUrl = subV.menuUrl
                        v.customMenuId = subV.menuId
                        return true
                      }
                    }
                  })
                }

                // 当二级导航有路由链接时,则为第一个,否则查找该二级下的三级导航是否有值,如果有,刚查找到的第一个进行跳转
                if (!isHasMenu) {
                  if (v.menuUrl) {
                    jumpRouterName = v.menuUrl.split(',')[0]
                    isHasMenu = true
                  } else {
                    resData.listMenu.some(subV => {
                      if (
                        subV.menuLevel === 3 &&
                        subV.parentMenuId === v.menuId
                      ) {
                        jumpRouterName = subV.menuUrl.split(',')[0]
                        isHasMenu = true
                        return true
                      }
                    })
                  }
                }
              }
            })

            // 存放好处理后的菜单列表
            allMenuList.forEach(v => {
              if (v.menuLevel === 2 || v.menuLevel === 3) {
                if (v.menuId) {
                  v.menuUrl = v.menuUrl.split(',')[0]
                }
              }
            })
            common.setLocalStorage(
              'dtcListMenu',
              window.JSON.stringify(allMenuList)
            )
            jumpRouterName = ''
            if (common.isShowItem('BDP', allMenuList)) {
              jumpRouterName = 'bigDataHome' // // 跳转到大数据平台首页
            }
            if (jumpRouterName) {
              this.$router.push({ name: jumpRouterName })
            } else {
              this.$router.push({ name: 'permission' })
            }
          } else {
            common.warningInfoTip(res.data.errorInfo)
          }
          this.isLogining = false
        })
        .catch(() => {
          this.isLogining = false
        })
    },

    // 忘记密码点击
    showForgotPwd () {
      this.forgotPwd.dialogVisible = true
    },

    // 忘记密码密码方法
    doForgotPwd (index) {
      if (this.forgotPwd.forgotUName === '') {
        return common.warningInfoTip(this.LANMSG.forgotPwd.userNamePlaceholder)
      }
      if (index === 0) {
        const loadTips = Loading.service()
        this.$ajax({
          method: 'get',
          url: `${apiPath.common.sendEmail}`,
          params: { userName: this.forgotPwd.forgotUName }
        }).then(response => {
          loadTips.close()

          if (response.status === 0) {
            common.warningInfoTip(
              `${this.LANMSG.forgotPwd.smsOkTips} ${this.forgotPwd.forgotUName} ${this.LANMSG.forgotPwd.smsOkTips2}`
            )
          }
        })
      } else {
        if (this.forgotPwd.forgotSms === '') {
          return common.warningInfoTip(this.LANMSG.forgotPwd.smsPlaceholder)
        }
        const loadTips = Loading.service()

        this.$ajax({
          method: 'put',
          url: `${apiPath.common.resetPWD}`,
          data: {
            userName: this.forgotPwd.forgotUName,
            verificationCode: this.forgotPwd.forgotSms
          }
        }).then(response => {
          loadTips.close()
          if (response.status === 0) {
            this.forgotPwd.dialogVisible = false
            common.warningInfoTip(
              `${this.LANMSG.forgotPwd.newPwdOkTips} ${response.data} ${this.LANMSG.forgotPwd.newPwdOkTips2}`
            )
          } else {
            common.warningInfoTip(response.data.errorInfo)
          }
        })
      }
    },

    clearForgotPwd () {
      const obj = {
        // 忘记密码
        dialogVisible: false,
        forgotUName: '',
        forgotSms: ''
      }
      return obj
    },

    doForgotPwdClose () {
      this.forgotPwd = this.clearForgotPwd()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/login/login.js